module.exports = __webpack_public_path__ + "img/EAL.7718e610.svg";